
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/logout/success",
      function () {
        return require("private-next-pages/phone/logout/success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/logout/success"])
      });
    }
  